import * as safeApi from 'api'
import { get } from 'lodash'

import { purchasePassReceieved } from 'redux/slices/passes'
import { provideAccess } from 'redux/slices/paywall'
import { onUserAccessPrivateEvent } from 'redux/slices/messagingBanner/thunks'
import * as Result from 'data/ApiResult'
import { createAsyncThunk } from '@reduxjs/toolkit'
interface AccessCodeData {
    displayName: string
    email: string
    password: string
    accessCode: string
    showId: string
}

export const validateAccessCode = createAsyncThunk(
    'accessCode/validateAccessCode',
    async (data: AccessCodeData, { dispatch, rejectWithValue }) => {
        const validateAccessResult = await safeApi.validateAccessCode(data)

        return Result.cata(validateAccessResult, {
            Success: async accessCode => {
                dispatch(purchasePassReceieved(accessCode))
                dispatch(onUserAccessPrivateEvent())
                dispatch(provideAccess())
                return
            },
            HttpError: err => {
                const status = get(err, 'response.data.statusCode')
                switch (status) {
                    case 404:
                        return rejectWithValue('This event is not valid')
                    case 400:
                    default:
                        return rejectWithValue({
                            currentCode: data.accessCode,
                            message: 'The Access Code provided is not valid',
                        })
                }
            },
            _: console.error,
        })
    },
)
